export var SmsReceiveStatusType;
(function (SmsReceiveStatusType) {
    SmsReceiveStatusType["SUCCESS"] = "success";
    SmsReceiveStatusType["FAILURE"] = "failure";
    SmsReceiveStatusType["WAITING"] = "waiting";
    SmsReceiveStatusType["UNKNOWN"] = "unknown";
    SmsReceiveStatusType["OTHER"] = "other";
})(SmsReceiveStatusType || (SmsReceiveStatusType = {}));
//# sourceMappingURL=SmsReceiveStatusType.js.map